export const Types = {
    SNACKBAR_SUCCESS: "SNACKBAR_SUCCESS",
    SNACKBAR_ERROR: "SNACKBAR_ERROR",
    SNACKBAR_INFO: "SNACKBAR_INFO",
    SNACKBAR_CLEAR: "SNACKBAR_CLEAR",
};

export const showSuccessSnackbar = (message) => ({
    type: Types.SNACKBAR_SUCCESS,
    message: message,
});

export const showErrorSnackbar = (message) => ({
    type: Types.SNACKBAR_ERROR,
    message: message,
});

export const showInfoSnackbar = (message) => ({
    type: Types.SNACKBAR_INFO,
    message: message,
});

export const clearSnackbar = () => ({
    type: Types.SNACKBAR_CLEAR,
});
